(function () {
  'use strict';
  var stage = document.querySelector('.luxe-hero__stage--sirv');
  if (!stage) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Sirv measures its container once, when it builds the viewer, and sizes the
     spin canvas from that. On these pages the build happens behind the
     preloader while the stage is still opacity:0 and mid-layout, so it reads
     nothing useful, falls back to the sequence's native frame size — 1920x1080
     — and never fits itself to the box afterwards. That is why the render
     ignored every height the stage was given and simply cropped instead.

     Sirv does re-layout on a window resize, so one is dispatched once the
     stage is genuinely on screen with real dimensions. Debounced, because
     several of these can arrive together. */
  var nudge = 0;
  function refit() {
    clearTimeout(nudge);
    nudge = setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
    }, 60);
  }

  function reveal() {
    stage.classList.add('is-revealed');
    refit();
    // frames stream in after the viewer is built, so take one more pass once
    // the first of them have had a moment to land
    setTimeout(refit, 600);
  }

  if (window.__czardIntro) {
    reduce ? reveal() : requestAnimationFrame(reveal);
  } else {
    document.addEventListener('czard:intro', function () {
      reduce ? reveal() : requestAnimationFrame(reveal);
    }, { once: true });
  }

  /* Keeps it fitted through anything that changes the band's height later —
     an orientation change, or the vh-based rules resolving differently.
     Keyed on the stage's own height, which is CSS-driven: the canvas Sirv
     resizes in response lives inside the stage and cannot change it, so this
     cannot feed itself. */
  if ('ResizeObserver' in window) {
    var lastH = 0;
    new ResizeObserver(function (entries) {
      var h = Math.round(entries[0].contentRect.height);
      if (h && h !== lastH) {
        lastH = h;
        refit();
      }
    }).observe(stage);
  }
})();
